import { css } from "styled-components";

export default {
  baseStyles: css``
};



// WEBPACK FOOTER //
// ./src/styles/base.js